import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import SmallClientChipV2 from "../../SmallClientChipV2";
import {
  formatCompactNoteType,
  getStylesForNoteType,
} from "./notesContainerCompactHelpers";

function NoteTypeIcon({ noteType }) {
  const iconStyle = {
    fontSize: "40px",
    color: getStylesForNoteType(noteType).color,
  };

  switch (noteType) {
    case "endOfShift":
      return <AccessTimeIcon style={iconStyle} />;
    case "groupNote":
      return <GroupIcon style={iconStyle} />;
    case "handoverNote":
      return <SwapHorizIcon style={iconStyle} />;
    default:
      return null;
  }
}

function NotesContainerCompactListItem(props) {
  const {
    noteType,
    noteDate,
    noteTime,
    noteContent,
    generalAnnouncement,
    clientFirstName,
    clientLastName,
    clientPic,
    onOpen,
    onMenuClick,
    openMenu,
    anchorEl,
    onMenuClose,
    onDelete,
    translate,
  } = props;

  const noteStyles = getStylesForNoteType(noteType);
  const hasTypeIcon = ["endOfShift", "groupNote", "handoverNote"].includes(
    noteType
  );
  const noteDateValue = noteDate ? new Date(noteDate) : null;

  return (
    <div
      style={{
        width: "100%",
        height: "80px",
        display: "flex",
        flexDirection: "row",
        borderBottom: "1px solid lightgrey",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
    >
      <div
        style={{ display: "flex", flexDirection: "row", width: "100%" }}
        onClick={onOpen}
      >
        <div
          style={{
            width: "10%",
            height: "80px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignContent: "center",
            alignItems: "center",
            paddingLeft: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "15px",
            }}
          >
            <div
              style={{
                color: "#a3a3a4",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              {noteDateValue
                ? noteDateValue
                    .toLocaleString("en-US", { month: "short" })
                    .toUpperCase()
                : ""}
            </div>
            <div
              style={{
                color: "black",
                fontSize: "20px",
                lineHeight: "18px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {noteDateValue ? noteDateValue.getDate() : ""}
            </div>
            <div
              style={{
                color: "#a3a3a4",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              {noteDateValue ? noteDateValue.getFullYear() : ""}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                color: "black",
                fontSize: "16px",
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              {noteTime ? noteTime.split(":")[0] : ""}
            </div>
            <div
              style={{
                color: "black",
                fontSize: "20px",
                lineHeight: "16px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {noteTime && noteTime.split(":")[1]
                ? noteTime.split(":")[1].slice(0, 2)
                : ""}
            </div>
            <div
              style={{
                color: "#a3a3a4",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              {noteTime ? noteTime.split(" ")[1] : ""}
            </div>
          </div>
        </div>

        <div
          style={{
            width: "20%",
            height: "80px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingLeft: hasTypeIcon ? "30px" : "0px",
          }}
        >
          {hasTypeIcon ? (
            <NoteTypeIcon noteType={noteType} />
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
              }}
            >
              <SmallClientChipV2
                firstName={clientFirstName}
                lastName={clientLastName}
                avatar="1"
                clientPic={clientPic}
              />
            </div>
          )}
        </div>

        <div
          style={{
            width: "50%",
            height: "80px",
            padding: "10px",
            fontStyle: "italic",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              height: "100%",
              overflow: "hidden",
              position: "relative",
              zIndex: 1,
            }}
          >
            {noteType === "handoverNote" ? generalAnnouncement : noteContent}
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              left: 0,
              width: "100%",
              height: "20px",
              backgroundImage:
                "linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1))",
              zIndex: 2,
            }}
          ></div>
        </div>

        <div
          style={{
            width: "15%",
            height: "80px",
            display: "flex",
            justifyContent: "flex-start",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              backgroundColor: noteStyles.backgroundColor,
              paddingLeft: "7px",
              paddingRight: "7px",
              borderRadius: "10px",
              color: noteStyles.color,
              fontWeight: "500",
              height: "20px",
            }}
          >
            {formatCompactNoteType(noteType)}
          </div>
        </div>
      </div>

      <div
        style={{
          width: "5%",
          height: "75px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton onClick={onMenuClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={openMenu}
          onClose={onMenuClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={onOpen}>{translate("Edit")}</MenuItem>
          <MenuItem onClick={onDelete} sx={{ color: "red" }}>
            {translate("Delete")}
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
}

export default NotesContainerCompactListItem;
